import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
    typography: {
      fontFamily: [
        "Nunito",
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ].join(",")
    },
    palette: {
      primary: {
        main: "#1b61a1"
      },
      secondary: {
        main: "#279e75"
      }
    }
  });

export default theme;